import { PageContainer } from "src/components/organisms/contents";
import { ReactComponent as IconImgPlus } from "../../../styles/assets/svg/icon_imgPlus.svg";
import { ReactComponent as IconTrash } from "../../../styles/assets/svg/icon_trash.svg";
import { ReactComponent as IconNoimg } from "../../../styles/assets/svg/icon_noImage.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { Buttons } from "src/components/atoms/Buttons";
import { useEffect, useRef, useState } from "react";
import { InputTextarea } from "src/components/atoms/Inputs/InputTextarea";
import { ModalDatePicker } from "src/components/molecules/ModalDatePicker";
import { inputBox } from "src/pages/register/UserRegisterInfo";
import { FoodInfo } from "./FoodInfo";
import Slider from "react-slick";
import { confirmDialog } from "src/components/containers/ConfirmDialog";
import { showAlert } from "src/components/containers/Alert";
import { formatToAmPm, parseTo24Hour } from "src/common/hooks/userTimeFormat";
import {
  useAIcreateDiet,
  useCreateDiet,
  useSelectedDiet,
  useUpdateDiet,
} from "src/common/hooks/useDietRegister";
import { useImgUpload } from "src/common/hooks/useImgRegister";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";
import { FadeLoading } from "src/components/atoms/Spinners/FadeLoading";
import { ModalDietFile } from "src/components/molecules/ModalDietFile";
import { titleText } from "src/components/atoms/MainHeaderBox/MainConHeader";

// EXIF 완전 무시, 항상 원본 픽셀 그대로(canvas drawImage만) 미리보기/서버 이미지 생성
const getRawImageUrl = (file: File | Blob): Promise<string> =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = function (event) {
      const img = new window.Image();
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        if (ctx) {
          ctx.drawImage(img, 0, 0);
          canvas.toBlob((blob) => {
            if (blob) {
              resolve(URL.createObjectURL(blob));
            }
          }, file.type);
        }
      };
      if (event.target && event.target.result) {
        img.src = event.target.result as string;
      }
    };
    reader.readAsDataURL(file);
  });

export const ContentsBox = styled.div`
  width: 100%;
  padding: 16px;
  background: var(--white, white);
  box-shadow: 0px 4px 11px rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: flex;

  p {
    width: 100%;
    color: var(--neutral-700, #404040);
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }

  -ms-overflow-style: none; /* IE, Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
`;

const meals = ["아침", "점심", "저녁", "간식", "야식", "기타"];

interface Slide {
  oid: string;
  type: "img" | "add";
  filePath?: string; // 미리보기용 URL
  localPreview?: string;
  file?: File; // 실제 파일 데이터
  groupIndex?: number;
}

export const DietWirtePage = () => {
  const navi = useNavigate();
  // const { mode } = useParams(); // AI | 직접등록 구분 urlParams
  const { state } = useLocation(); // selectedDiet oid 가져오기
  const { mode } = useParams();
  const [open, setOpen] = useState<boolean>(false);
  const [modalRef, setModalRef] = useState<boolean>(false);
  const [capMode, setCapMode] = useState<boolean>(false);
  const [isImgLoading, setIsImgLoading] = useState<boolean>(false); // 이미지 업로드 로딩 상태
  const [showDateModal, setShowDateModal] = useState<boolean>(false); // 음식정보 상태

  const [isActive, setIsActive] = useState<string | null>(""); // 식사 상태 관리

  const [timer, setTimer] = useState(""); // 시간 상태 관리

  // 메모 상태 관리
  const [memo, setMemo] = useState("");

  /* swiper 임시 바인딩 */
  const [slides, setSlides] = useState<Slide[]>([
    { oid: "", type: "add" },
    { oid: "", type: "add" },
    { oid: "", type: "add" },
    { oid: "", type: "add" },
  ]);

  /* selected한 데이터 불러오기 */
  const { data: dietData = [], isLoading } = useSelectedDiet(
    state?.date,
    state?.mealType
  );

  /* AI 식단 생성 api */
  const { mutateAsync: createAIDiet } = useAIcreateDiet();

  /* 식단 생성 api */
  const { mutateAsync: createDiet } = useCreateDiet();

  /* diet 업데이트 */
  const { mutateAsync: updateDiet } = useUpdateDiet();

  // 그룹디테일 추출
  const { groupedDetails = [], ...withoutGroupedDetails } = dietData?.[0] ?? {};

  // 음식 정보 상태
  const [foodInfo, setFoodInfo] = useState<any[]>([]);

  // AI 분석 시 파일창 open
  useEffect(() => {
    if (!isLoading && mode === "AI" && dietData.length === 0) {
      // iOS는 자동 open 불가 → 안내 모달 표시
      setOpen(true);
    }
  }, [isLoading, mode, dietData.length]);

  useEffect(() => {
    if (modalRef === true || capMode === true) {
      setTimeout(() => {
        fileInputRef.current?.click();
        setCapMode(false);
        setModalRef(false);
        setOpen(false);
      }, 300);
    }
  }, [modalRef, capMode]);

  useEffect(() => {
    if (dietData.length > 0) {
      const first = dietData[0];

      setIsActive(first.mealType);
      setTimer(formatToAmPm(first.mealTime));
      setMemo(first.memo);

      if (!first.groupedDetails) return;
      // groupDetail 초기 세팅

      // slide 구성
      if (first.groupedDetails) {
        setFoodInfo(
          first.groupedDetails.map((g: any) => ({
            ...g,
            details: g.details.map((d: any) => ({
              ...d,
              qty: Number(d.qty) || 1,
            })),
          }))
        );

        const slidesData: Slide[] = first.groupedDetails.map((g) => ({
          oid: g.fileOid,
          type: "img",
          filePath: g.fileUrl,
        }));

        // slide 마지막에 add slide 추가
        slidesData.length < 5 && slidesData.push({ oid: "", type: "add" });
        setSlides(slidesData);
      }
    }
  }, [dietData]);

  const [current, setCurrent] = useState<number>(0); // slide pagenations index 상태
  const fileInputRef = useRef<HTMLInputElement | null>(null); // file ref

  /* 이미지 업로드 */
  const { mutateAsync: uploadFile } = useImgUpload();

  // 시간 format
  const formatTime = (h: string, m: string, d: string) =>
    `${d} ${String(h).padStart(2, "0")} : ${String(m).padStart(2, "0")}`;

  // 빈 음식 정보 추가
  const addFood = () => {
    setFoodInfo((prev) => {
      // foodInfo가 비어있으면 첫 그룹 생성
      if (!prev || prev.length === 0) {
        return [
          {
            oid: "", // 필요하면 uuid
            details: [
              {
                oid: undefined,
                mealName: "",
                calorie: "0",
                qty: 1,
                unit: "인분",
                dietOid: dietData?.[0]?.oid || Date.now().toString(),
                fileOid: "",
                fileUrl: null,
                aiYn: false,
                createIp: null,
                createUserId: null,
                createdAt: null,
                updateIp: null,
                updateUserId: null,
                updatedAt: null,
              },
            ],
          },
        ];
      }

      // current가 기존 그룹 인덱스이면 해당 그룹에 추가
      if (current < prev.length) {
        return prev.map((g, idx) =>
          idx === current
            ? {
                ...g,
                details: [
                  ...g.details,
                  {
                    oid: undefined,
                    dietOid: g.oid || dietData?.[0]?.oid || "",
                    mealName: "",
                    calorie: "0",
                    qty: 1,
                    unit: "인분",
                    fileOid: groupedDetails[current]?.fileOid || "",
                    fileUrl: groupedDetails[current]?.fileUrl || null,
                    aiYn: false,
                    createIp: null,
                    createUserId: null,
                    createdAt: null,
                    updateIp: null,
                    updateUserId: null,
                    updatedAt: null,
                  },
                ],
              }
            : g
        );
      }

      // current가 기존 그룹 인덱스를 벗어나면 마지막 뒤에 새 그룹 추가
      return [
        ...prev,
        {
          oid: "", // 필요하면 uuid
          details: [
            {
              oid: undefined,
              mealName: "",
              calorie: "0",
              qty: 1,
              unit: "인분",
              dietOid: dietData?.[0]?.oid || "",
              fileOid: "",
              fileUrl: null,
              aiYn: false,
              createIp: null,
              createUserId: null,
              createdAt: null,
              updateIp: null,
              updateUserId: null,
              updatedAt: null,
            },
          ],
        },
      ];
    });
  };

  /* 입력 확인 조건 */
  const isAllFilled = foodInfo.length > 0 && !!isActive;

  // 파일 선택 핸들러
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) return;

    if (!file.type.startsWith("image/")) {
      showAlert("이미지 파일만 업로드할 수 있습니다.");
      return;
    }

    // EXIF 무시, 원본 픽셀 그대로 미리보기 생성
    const previewUrl = await getRawImageUrl(file);
    setSlides((prev) =>
      prev.map((s, idx) =>
        current === idx
          ? {
              ...s,
              type: "img",
              localPreview: previewUrl,
              filePath: previewUrl,
              file,
              groupIndex: current,
            }
          : s
      )
    );

    e.target.value = ""; // 같은 파일 다시 선택 가능하게 초기화

    // ✅ AI 모드일 때는 AI 분석 API 호출
    if (mode === "AI") {
      try {
        setIsImgLoading(true);
        // 파일을 서버로 업로드 후 AI 분석 요청
        const { data } = await createAIDiet(file);

        const aiResults = data.result;

        setFoodInfo((prev) => {
          const newDetails =
            aiResults.length > 0
              ? aiResults.map((item: any) => ({
                  oid: undefined,
                  mealName: item.name || "",
                  calorie: item.calories?.toString() || "0",
                  qty: 1,
                  unit: "인분",
                  dietOid: prev[current]?.oid || dietData?.[0]?.oid || "",
                  fileOid: "",
                  fileUrl: slides[current]?.filePath || null,
                  aiYn: true,
                  createIp: null,
                  createUserId: null,
                  createdAt: null,
                  updateIp: null,
                  updateUserId: null,
                  updatedAt: null,
                }))
              : [
                  {
                    oid: undefined,
                    mealName: "",
                    calorie: "0",
                    qty: 1,
                    unit: "인분",
                    dietOid: prev[current]?.oid || dietData?.[0]?.oid || "",
                    fileOid: "",
                    fileUrl: slides[current]?.filePath || null,
                    aiYn: true,
                    createIp: null,
                    createUserId: null,
                    createdAt: null,
                    updateIp: null,
                    updateUserId: null,
                    updatedAt: null,
                  },
                ];

          // current 인덱스에 그룹이 없으면 미리 채워주기
          const updated = [...prev];
          while (updated.length <= current) {
            updated.push({
              oid: "", // 새 그룹 oid
              details: [],
            });
          }

          // 해당 current 인덱스 그룹에 details 추가
          updated[current] = {
            ...updated[current],
            details: [...updated[current].details, ...newDetails],
          };

          return updated;
        });
        if (aiResults.length === 0) {
          showAlert("AI 분석 : 음식 인식 실패");
        }
      } catch (error) {
        showAlert("AI 분석에 실패했습니다.");
      } finally {
        setIsImgLoading(false);
      }
    }
    // 파일 선택 후 미리보기 업데이트하는 부분 아래에 추가
    setSlides((prev: any) => {
      const updated = prev.map((s: any, idx: number) =>
        current === idx
          ? {
              ...s,
              type: "img",
              localPreview: previewUrl,
              filePath: previewUrl,
              file,
              groupIndex: current,
            }
          : s
      );

      // add 타입이 없거나, 마지막이 add가 아니면 add 추가 (최대 5개)
      if (updated.length < 5 && updated[updated.length - 1].type !== "add") {
        updated.push({ oid: "", type: "add" });
      }

      return updated;
    });
  };

  /* slider 옵션 */
  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
    centerMode: true,
    centerPadding: "0",
    beforeChange: (_: number, next: number) => {
      setCurrent(next);
    },
  };

  /* 나가기 모달 */
  const handleOutPage = async () => {
    const isConfirm = await confirmDialog({
      text: `지금 나가면 작성한 내용이 저장되지 않아요.\n 계속 작성하시겠어요?`,
      title: "작성 중인 내용이 있어요",
      options: {
        trueButtonText: "계속 작성하기",
        falseButtonText: "작성 취소",
      },
    });
    if (!isConfirm) {
      navi("/diet", { replace: true, state: { date: state?.date } });
    }
  };

  /* 기록하기 */
  const handleSave = async () => {
    if (!isAllFilled) return;
    setIsImgLoading(true);

    // 1️⃣ slides 중 type === 'img' && file 있는 것만 필터
    const filesToUpload = slides.filter((s) => s.type === "img" && s.file);

    // 2️⃣ 파일 업로드 (Promise.all 사용)
    const uploadedFiles: { groupIndex: number; oid: string }[] =
      await Promise.all(
        filesToUpload.map(async (slide) => {
          if (!slide.file) return { groupIndex: slide.groupIndex!, oid: "" };
          try {
            const { response } = await uploadFile(slide.file);
            setIsImgLoading(false);
            return { groupIndex: slide.groupIndex!, oid: response.oid };
          } catch (err) {
            showAlert("이미지 파일 업로드 실패");
            return { groupIndex: slide.groupIndex!, oid: "" };
          }
        })
      );

    // 3️⃣ 모든 그룹 details 풀어서 전송용 배열 구성
    let sendDetails: any[] = [];
    foodInfo.forEach((group, groupIndex) => {
      group.details.forEach((detail: any) => {
        const uploaded = uploadedFiles.find((f) => f.groupIndex === groupIndex);
        sendDetails.push({
          ...detail,
          fileOid: uploaded?.oid || detail.fileOid,
        });
      });
    });

    const { mealName, totalCalorie, aiYn, fileUrl, fileOid, ...restDetails } =
      withoutGroupedDetails;

    // 3️⃣ 이제 food record API 호출
    const payload = {
      ...restDetails,
      mealType: isActive,
      mealTime: parseTo24Hour(timer) || null,
      memo: memo,
      details: sendDetails,
    };

    if (dietData.length === 0) {
      const dietDate =
        state?.date && state?.date !== null
          ? state.date
          : new Date().toISOString().slice(0, 10);

      const createPayload = {
        oid: undefined,
        dietDate,
        mealType: isActive,
        mealTime: parseTo24Hour(timer) || null,
        memo: memo,
        details: sendDetails,
        useYn: true,
      };
      await createDiet(createPayload); // 서버에서 diet oid 생성
      navi("/diet", {
        replace: true,
        state: { date: dietDate, complete: true },
      });
    } else {
      await updateDiet(payload);
      navi("/diet", {
        replace: true,
        state: { toast: "식단 기록 완료!", date: state?.date, complete: false },
      });
    }
  };

  /* 이미지 삭제하기 */
  const handleDeleteImg = async (groupIndex: number) => {
    const isConfirm = await confirmDialog({
      text: `해당 이미지를 삭제하시겠습니까?`,
      title: "삭제하기",
      options: {
        trueButtonText: "돌아가기",
        falseButtonText: "삭제하기",
      },
    });
    if (!isConfirm) {
      setSlides((prev) =>
        prev.map((s, idx) =>
          idx === groupIndex
            ? { ...s, type: "add", filePath: "", file: undefined }
            : s
        )
      );

      // 서버 전송용 foodInfo 업데이트 (fileOid만 null)
      setFoodInfo((prev) =>
        prev.map((g, idx) =>
          idx === groupIndex
            ? {
                ...g,
                details: g.details.map((d: any) => ({ ...d, fileOid: null })),
              }
            : g
        )
      );
    }
  };

  /* 식단 삭제하기 */
  const handleDelete = async () => {
    const payload = { oid: dietData[0]?.oid, useYn: false };
    const isConfirm = await confirmDialog({
      text: `해당 식단을 삭제하시겠습니까?`,
      title: "삭제하기",
      options: {
        trueButtonText: "삭제하기",
        falseButtonText: "돌아가기",
      },
    });
    if (isConfirm) {
      await updateDiet(payload);
      navi("/diet", {
        replace: true,
        state: { toast: "식단 기록이 삭제되었습니다!", date: state?.date },
      });
    }
  };

  // 서버에서 불러온 이미지도 getRawImageUrl로 localPreview 생성
  useEffect(() => {
    const slidesToFix = slides.filter(
      (s) => s.type === "img" && !!s.filePath && !s.localPreview
    );
    if (slidesToFix.length === 0) return;
    slidesToFix.forEach(async (slide) => {
      try {
        let blob: Blob | null = null;
        let fetchUrl = "";
        if (slide.filePath?.startsWith("blob:")) {
          fetchUrl = slide.filePath;
        } else if (process.env.REACT_APP_API_FILE && slide.filePath) {
          fetchUrl = process.env.REACT_APP_API_FILE + slide.filePath;
        }
        if (!fetchUrl) return;
        const res = await fetch(fetchUrl);
        if (!res.ok) {
          console.warn("이미지 fetch 실패", fetchUrl);
          return;
        }
        blob = await res.blob();
        if (!blob) return;
        // 디버깅: blob 타입과 사이즈 확인
        // console.log("이미지 blob", blob, "from", fetchUrl);
        const url = await getRawImageUrl(blob);
        setSlides((prev) =>
          prev.map((s) =>
            s.oid === slide.oid &&
            s.filePath === slide.filePath &&
            !s.localPreview
              ? { ...s, localPreview: url }
              : s
          )
        );
      } catch (e) {
        console.error("getRawImageUrl 처리 실패", e);
      }
    });
    // eslint-disable-next-line
  }, [slides]);

  return (
    <PageContainer isNavBar={false} active={null}>
      <>
        {isImgLoading && <FadeLoading />}
        {/* 헤더 */}
        <SubConHeader
          title="식단 기록"
          onClickArrow={() =>
            isAllFilled
              ? navi("/diet", {
                  replace: true,
                  state: { date: state?.date },
                })
              : handleOutPage()
          }
        />

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: 24,
            paddingBottom: "90px",
          }}
        >
          {/* 상단 내용 */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 2,
              width: "100%",
            }}
          >
            <div
              style={{
                color: "var(--neutral-800, #262626)",
                fontSize: 20,
                fontWeight: "700",
                lineHeight: "28px",
              }}
            >
              {dietData.length === 0 ? "식단 기록하기" : "식단 수정하기"}
            </div>
            <div
              style={{
                color: "var(--neutral-500, #737373)",
                fontSize: 16,
                fontWeight: "500",
                lineHeight: "24px",
              }}
            >
              음식에 대한 사진과 정보를 기록해주세요.
            </div>
          </div>

          <ContentsBox>
            <p>음식 사진</p>
            <div
              style={{
                width: "100%",
                height: "100%",
                maxWidth: "371px",
                maxHeight: "371px",
                border: "none",
              }}
            >
              {/* 숨겨진 input */}
              <input
                type="file"
                accept="image/*" // img만 업로드 가능
                style={{ display: "none" }}
                capture={capMode ? "environment" : undefined}
                ref={fileInputRef}
                onChange={handleFileChange}
              />
              <Slider {...settings}>
                {slides?.map((s) =>
                  s.type === "img" && (s.filePath || s.localPreview) ? (
                    <div key={s.oid}>
                      <div
                        style={{
                          position: "relative",
                          width: "100%",
                          height: "100%",
                          maxWidth: "371px",
                          maxHeight: "371px",
                        }}
                      >
                        <img
                          src={
                            s.localPreview
                              ? s.localPreview
                              : process.env.REACT_APP_API_FILE! + s.filePath
                          }
                          alt={"preview"}
                          onClick={() => {
                            fileInputRef.current?.click(); // 파일창 열기;
                            setCapMode(false);
                          }} // 클릭 시 파일 선택
                          onError={(e) => {
                            setSlides((prev) =>
                              prev.map((slide) =>
                                slide.oid === s.oid
                                  ? {
                                      ...slide,
                                      type: "add",
                                      filUrl: undefined,
                                      localPreview: undefined,
                                      filePath: "",
                                    }
                                  : slide
                              )
                            );
                          }}
                          style={{
                            width: "98%",
                            height: "100%",
                            maxWidth: "371px",
                            maxHeight: "371px",
                            objectFit: "cover",
                            display: "block",
                            borderRadius: 8,
                          }}
                        />

                        <div
                          style={{
                            position: "absolute",
                            left: "5.5%",
                            bottom: "5.5%",
                            width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            background: "#00000080",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 999,
                          }}
                          onClick={() => handleDeleteImg(current)}
                        >
                          <IconTrash />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div key={s.oid}>
                      <button
                        style={{
                          width: "98%",
                          height: "100%",
                          background: "var(--neutral-100, #F5F5F5)",
                          borderRadius: 8,
                          padding: "36px 0",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          border: "none",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          fileInputRef.current?.click(); // 파일창 열기;
                          setCapMode(false);
                        }} // 클릭 시 파일 선택
                      >
                        <div
                          style={{
                            borderRadius: 8,
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            gap: 8,
                          }}
                        >
                          <div
                            style={{
                              width: 48,
                              height: 48,
                              overflow: "hidden",
                            }}
                          >
                            {s.filePath === null ? (
                              <IconNoimg />
                            ) : (
                              <IconImgPlus />
                            )}
                          </div>
                          <div
                            style={{
                              color: "var(--neutral-700, #404040)",
                              fontSize: 14,
                              fontWeight: "500",
                              lineHeight: "20px",
                            }}
                          >
                            {s.filePath === null
                              ? "사진 없음"
                              : "눌러서 사진 추가하기"}
                          </div>
                        </div>
                      </button>
                    </div>
                  )
                )}
              </Slider>
            </div>

            {/* swiper 부분 */}
            <div
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                gap: 8,
                marginBottom: "10px",
              }}
            >
              {slides.map((_, idx) => (
                <div
                  key={idx}
                  style={{
                    width: current === idx ? 24 : 8,
                    height: 8,
                    borderRadius: 100,
                    background: current === idx ? "#FFA14D" : "#E5E5E5",
                    transition: "all 0.3s ease",
                  }}
                />
              ))}
            </div>

            <FoodInfo
              data={foodInfo[current]?.details || []}
              setFoodInfo={(updater) => {
                setFoodInfo((prev) =>
                  prev.map((g, idx) =>
                    idx === current
                      ? {
                          ...g,
                          details:
                            typeof updater === "function"
                              ? updater(g.details)
                              : updater,
                        }
                      : g
                  )
                );
              }}
            />
            <Buttons
              type="button"
              size="lg"
              layout="outline"
              label="+ 음식정보추가"
              onClick={addFood}
            />
          </ContentsBox>

          <ContentsBox>
            <p>언제 식사하셨나요?</p>
            <div
              style={{
                width: "100%",
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: 8,
              }}
            >
              {meals.map((meal) => {
                const active = isActive === meal;
                return (
                  <div
                    key={meal}
                    onClick={() => {
                      dietData.length === 0 && setIsActive(meal);
                    }}
                    style={{
                      width: "100%",
                      height: 44,
                      background: active
                        ? "var(--neutral-700, #404040)"
                        : "var(--neutral-100, #F5F5F5)",
                      borderRadius: 8,
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 10,
                      display: "flex",
                      transition: "background-color 0.3s ease, color 0.3s ease",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      style={{
                        color: active ? "white" : "var(--neutral-700, #404040)",
                        fontSize: 16,
                        fontWeight: "500",
                        lineHeight: "24px",
                      }}
                    >
                      {meal}
                    </div>
                  </div>
                );
              })}
            </div>
            <p>식사 시간</p>
            <div
              style={{
                ...inputBox,
                width: "100%",
                height: 56,
                padding: "0 16px",
                cursor: "pointer",
                position: "relative",
              }}
              onClick={() => setShowDateModal(true)}
            >
              <span style={{ flex: 1, fontSize: 14, color: "#525252" }}>
                {timer !== "" ? (
                  timer
                ) : (
                  <span style={{ color: "#D4D4D4" }}>
                    식사 시간을 선택해주세요
                  </span>
                )}
                <svg
                  width="18px"
                  height="18px"
                  viewBox="0 0 24 24"
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <path
                    d="M6 9l6 6 6-6"
                    stroke="#9CA3AF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                </svg>
              </span>
            </div>

            {/* 모달 */}
            {showDateModal && (
              <ModalDatePicker
                data={timer}
                title="시간"
                onClose={() => setShowDateModal(false)}
                onConfirm={(hour, min, dayNights) => {
                  setTimer(formatTime(hour, min, dayNights));
                  setShowDateModal(false);
                }}
                time={true}
              />
            )}

            <p>메모</p>
            <InputTextarea
              name="memo"
              size="lg"
              width={100}
              height={136}
              placeholder="ex) 흑미밥, 김치, 된장찌개, 콩자반"
              value={memo}
              onChange={(e: any) => setMemo(e.target.value)}
            />
          </ContentsBox>
          {/* 하단 버튼 */}
          {dietData[0]?.oid ? (
            <div
              style={{
                width: "100%",
                maxWidth: "45rem",
                padding: 16,
                bottom: 0,
                position: "fixed",
                // margin: "0 -16px",
                background: "white",
                borderTop: "1px rgba(0, 0, 0, 0.05) solid",
                display: "flex",
                // flexDirection: "column",
                gap: 12,
                boxSizing: "border-box",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              <button
                style={{
                  width: "100%",
                  height: 48,
                  background: "#F5F5F5",
                  borderRadius: 8,
                  border: "none",
                  cursor: "pointer",
                  fontSize: 16,
                  fontWeight: 500,
                  color: "#FF5253",
                }}
                onClick={handleDelete}
              >
                삭제하기
              </button>
              <button
                style={{
                  width: "100%",
                  height: 48,
                  background: isAllFilled ? "#F57C00" : "#FFD9B3",
                  borderRadius: 8,
                  border: "none",
                  cursor: isAllFilled ? "pointer" : "",
                  fontSize: 16,
                  fontWeight: 500,
                  color: "white",
                }}
                disabled={!isAllFilled}
                onClick={handleSave}
              >
                수정완료
              </button>
            </div>
          ) : (
            <div
              style={{
                width: "100%",
                maxWidth: "45rem",
                padding: 16,
                bottom: 0,
                position: "fixed",
                // margin: "0 -16px",
                background: "white",
                borderTop: "1px rgba(0, 0, 0, 0.05) solid",
                display: "flex",
                flexDirection: "column",
                gap: 10,
                boxSizing: "border-box",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              <button
                style={{
                  height: 48,
                  background: isAllFilled ? "#F57C00" : "#FFD9B3",
                  borderRadius: 8,
                  border: "none",
                  cursor: isAllFilled ? "pointer" : "",
                  fontSize: 16,
                  fontWeight: 500,
                  color: "white",
                }}
                disabled={!isAllFilled}
                onClick={handleSave}
              >
                기록하기
              </button>
            </div>
          )}
        </div>
        {open && (
          <ModalDietFile
            setOpen={setOpen}
            titleText={titleText}
            setModalRef={setModalRef}
            setCapMode={setCapMode}
          />
        )}
      </>
    </PageContainer>
  );
};
